import { Controller } from "@hotwired/stimulus";
import { createConsumer } from "@rails/actioncable";
import { ApiMessage } from "~/types/devices";

export interface DeviceBaseOptions {
  channel: string;
  onConnection?: (connected: boolean) => void;
  onEvent?: (msg: string) => void;
}

export default class DeviceBase extends Controller {
  mac_address!: string;
  last_connected = false;
  connection: any;
  options!: DeviceBaseOptions;

  connectBase(options: DeviceBaseOptions) {
    const el = this.element as HTMLDivElement;
    this.mac_address = el.dataset.macaddress!;
    console.log(this.mac_address);
    this.options = options;

    let timer: number | null = null;
    const newState = (state: boolean) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        if (state) {
          $('#modalConnecting').modal('hide');
        } else {
          $('#modalConnecting').modal('show');
        }
      }, 500);
    };

    // show modal on start
    newState(false);

    const connected = (state: boolean) => {
      console.log(state ? "CONNECTED" : "DISCONNECTED");
      if (state !== this.last_connected) {
        newState(state);
      }
      this.last_connected = state;
      setTimeout(() => {
        options.onConnection?.(state);
      }, 50);
    };

    const event = (msg: string) => {
      options.onEvent?.(msg);
    };

    // setup ActionCable subscription
    const consumer = createConsumer();
    this.connection = consumer.subscriptions.create(
      { channel: this.options.channel, id: this.mac_address },
      {
        connected() {
          console.log("connected");
          this.perform("really_subscribed");
        },
        disconnected() {
          console.log("disconnected");
        },
        received: (data: ApiMessage) => {
          console.log(data);
          switch (data.action) {
            case "connection":
              connected(data.data != null && data.data.length > 0);
              break;
            case "event":
              event(data.msg);
              break;
          }
        },
      }
    );

    $('form.state').on('submit', function () {
      return false;
    });

    return { connected, event };
  }

  // optional helper for sending commands
  sendCmd(cmd: string) {
    console.log("sendCmd: " + cmd);
    if (this.connection) {
      this.connection.perform("command", { data: cmd });
    }
  }

}
